import styled from "styled-components";

export const HomeTabWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: -32px;
`;

export const TabWrapper = styled.div`
  width: 100%;
  padding-bottom: 9px;
  border-bottom: 1px solid #a4a4a4;
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const TabItem = styled.div<{ isActive: boolean }>`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isActive }) => (isActive ? "#6436e7" : "#A4A4A4")};
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
`;

export const ActiveIndicator = styled.div<{ activeIndex: number }>`
  position: absolute;
  bottom: -1px;
  left: ${({ activeIndex }) => `${activeIndex * 50}%`};
  width: 50%;
  height: 2px;
  background-color: #6436e7;
  transition: left 0.3s ease;
  z-index: 1;
`;

export const TabMenuContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const TabMenuSlider = styled.div<{ activeIndex: number }>`
  display: flex;
  width: 200%;
  transform: translateX(${({ activeIndex }) => `${-activeIndex * 50}%`});
  transition: transform 0.3s ease;
`;

export const TabMenuWrapper = styled.div`
  width: 50%;
  padding: 0px 30px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;

export const TabMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  cursor: pointer;
`;

export const TabMenuItemIcon = styled.img`
  width: 48px;
  height: 48px;
`;

export const TabMenuItemTitle = styled.div`
  font-weight: 600;
  font-size: 11px;
  line-height: 100%;
  text-align: center;
  color: #222222;
`;
